import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { HttpClient } from '@angular/common/http';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
    selector: 'contact-support',
    templateUrl: './contact-support.component.html',
    styleUrls: ['./contact-support.component.sass']
})
export class ContactSupportComponent implements OnInit {
    public subject: string = '';
    public message: string = '';
    private apiUrl = environment.runtime.hubconnectApiUrl;
    public showOverlay: boolean = false;
    private persona: string;


    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private modal: ModalService,
        private authHttp: HttpClient,
        private _gaSvc: GoogleAnalyticsService,
        private flashMessageService: FlashMessageService,
        public currentUserService: CurrentUserService
    ) {
        this.persona = this.currentUserService.toTitleCase(this.currentUserService.user.organizationType);
    }

    ngOnInit() {
        this._gaSvc.register('Contact Support', `${this.persona} has opened contact support form`);
    }

    public close() {
        this.modal.close();
    }

    public send() {
        this.showOverlay = true;
        const message = { subject: this.subject, message: this.message };
        return this.authHttp.post(`${this.apiUrl}/user/contact-support`, message)
            .toPromise()
            .then(() => {
                this._gaSvc.register('Contact Support', `${this.persona} has submitted a support request`);
                this.flashMessageService.updateMessage(`Your message has been sent`, 2000, 'success');
                this.close();
            }).catch((error) => {
                console.log(error)
                this.flashMessageService.updateMessage("Failed to send message, please try again later.", 3000);
                this.close()
            });
    }
}
